import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  timetable: {},
  student_list:{},
  params: {},
  byId: {},
  actionsloading: false,
});

export function myDayTimetableReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_MYDAY_TIMETABLE:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_MYDAY_TIMETABLE_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        timetable: action.payload.timetable || {},
        student_list: action.payload.student_list || {},
        actionsloading: false,
      };
    default:
      return state;
  }
}
